import React, { useState } from "react";
import AppsIcon from "@mui/icons-material/Apps";
import { Button, Popover } from "@mui/material";
import { useStyles } from "./AppMenu.styles";
import AppMenuItem from "./AppMenuItem.view";
import { useTranslation } from "react-i18next";
import Module1Icon from "components/Module1Icon";
import Module2Icon from "components/Module2Icon";
import { useModuleHome } from "hooks/useModuleHome";

const AppMenu = () => {
    const [anchorElForAppMenu, setAnchorElForAppMenu] = useState<HTMLButtonElement | null>(null);
    const isOpenAppMenu = Boolean(anchorElForAppMenu);
    const appMenuId = isOpenAppMenu ? "appMenu-popover" : undefined;
    const classes = useStyles();
    const { t } = useTranslation();
    const { goToAspenHome, goToRCAHome } = useModuleHome();

    const handleClickAppMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorElForAppMenu(event.currentTarget);
    };

    const handleCloseAppMenu = () => {
        setAnchorElForAppMenu(null);
    };

    const handleNavigateToAspen = () => {
        goToAspenHome();
        handleCloseAppMenu();
    };

    const handleNavigateToRCA = () => {
        goToRCAHome();
        handleCloseAppMenu();
    };

    return (
        <>
            <Button onClick={handleClickAppMenu} aria-describedby={appMenuId}>
                <AppsIcon className={classes.appMenu} />
            </Button>
            <Popover
                id={appMenuId}
                open={isOpenAppMenu}
                anchorEl={anchorElForAppMenu}
                onClose={handleCloseAppMenu}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
            >
                <main className={classes.mainWrapper}>
                    <AppMenuItem
                        icon={<Module1Icon className={classes.appMenuIcon} hideBackground />}
                        text={t("corporate_backoffice.corporate_layout.app_drawer.app_menu.downtime")}
                        onClick={handleNavigateToAspen}
                    />
                    <AppMenuItem
                        icon={<Module2Icon className={classes.appMenuIcon} hideBackground />}
                        text={t("corporate_backoffice.corporate_layout.app_drawer.app_menu.rca")}
                        onClick={handleNavigateToRCA}
                    />
                </main>
            </Popover>
        </>
    );
};

export default AppMenu;
